import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { parseDocumentVersionRef } from "../../../shared/references/contentReferences";
import { formatTimeAgo } from "../../../shared/formatting/relativeTimes";
import { useDocumentLabel } from "../../sources";
import type { RunlessItem } from "./runlessWaiting";

/**
 * A waiting item no Run row in view owns. It isn't a Run, so it doesn't look like one (Johannes, 5 Nov 08:44): the review
 * and result cards' look, what it is where a Run's name would sit, its title after it, then its time; no Run state, no
 * Run actions.
 */
export default function WaitingItemRow({ item }: { item: RunlessItem }) {
  const { t, i18n } = useTranslation();
  const document = useDocumentLabel(item.document === null ? null : parseDocumentVersionRef(item.document));
  const title = item.title ?? document;
  const kind = t(item.kind === "changeSet" ? "threads.toolTurn.valueKinds.change_set" : "reviews.kinds.knowledge_data");
  return (
    <li>
      <Link to={item.href} className="app-inbox-row app-card block space-y-1 p-2">
        <span className="app-title block min-w-0 break-words text-sm font-semibold" title={title}>
          <span className="app-text-muted font-normal">{kind} · </span>
          {title}
        </span>
        <span className="app-text-muted block text-xs">{formatTimeAgo(item.at, i18n.resolvedLanguage)}</span>
      </Link>
    </li>
  );
}
